import { CDN_URL } from "../utils/constants"

const RestaurantCard = (props) => {
  // ctrl+space for suggestions for tailwind css extensions if it doesn't show
  const { resData } = props
  const { name, cuisines, deliveryTime, avgRating } = resData?.info
  return (
    <div className="text-wrap p-4 mx-2 my-4 w-[300px] h-[400px] border-solid border-b-gray-600 bg-slate-500 shadow-lg rounded-lg hover:bg-white hover:translate-y-[-10px] transform transition-transform duration-300">
      <img
        className="w-[1000px] h-[150px] rounded-lg "
        alt="res-logo"
        src={CDN_URL + resData.info.cloudinaryImageId}
      ></img>
      <h3>{name}</h3>
      <article className="text-wrap break-all ">{cuisines.join(",")}</article>
      <h5>{deliveryTime}</h5>
      <h6>{avgRating} stars</h6>
    </div>
  )
}

export const closedRestaurant = (RestaurantCard) => {
  return (props) => {
    const { resData } = props
    console.log("props= " + props)
    return (
      <div>
        <label className="absolute p-2 bg-slate-800 text-slate-100 rounded-lg border-y-green-200 ">
          Closed
        </label>
        {/* or passing props using {...props}....this is spread operator which passes props directly which it receives */}
        <RestaurantCard resData={resData} />
      </div>
    )
  }
}

export default RestaurantCard
